import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams,App ,LoadingController} from 'ionic-angular';
import {ForseclousrestatementsPage} from '../forseclousrestatements/forseclousrestatements'
import {InterestratecertificatePage} from '../interestratecertificate/interestratecertificate'
import {WelcomeletterPage} from '../welcomeletter/welcomeletter'
import {StatementsofaccountsPage} from '../statementsofaccounts/statementsofaccounts'
import {ListoddocumentsPage} from '../listoddocuments/listoddocuments'
import {RepaymentsschedulePage} from '../repaymentsschedule/repaymentsschedule'
import { CommonProvider } from '../../providers/common/common';

@IonicPage()
@Component({
  selector: 'page-documentstatement',
  templateUrl: 'documentstatement.html',
})
export class DocumentstatementPage {
loanstatus:boolean=true
  constructor(
               public navCtrl: NavController,
               public navParams: NavParams,
               private app:App,
               private cp: CommonProvider,
               public loadingCtrl: LoadingController
             ) {}

  ionViewDidLoad() {

    if(this.navParams.data.loanParameterDetail.responseParameters[0].loanstatus=='Active'){
      this.loanstatus=false
    }
  }
  goToPageName(pageName){
     let nav = this.app.getRootNav();
  if(pageName=='fcsp'){
    // //console.log(UpdateinfoloadingsrPage)
    nav.push(ForseclousrestatementsPage)
  }else if(pageName=='soa'){
    //console.log(pageName)
    nav.push(StatementsofaccountsPage,this.navParams)
  }else if(pageName=='loi'){
    //console.log(pageName)
    nav.push(ListoddocumentsPage,this.navParams)
  }else if(pageName=='rs'){
    //console.log(pageName)
    nav.push(RepaymentsschedulePage,this.navParams)
  }else if(pageName=='icp'){
    //console.log(pageName)
    nav.push(InterestratecertificatePage,this.navParams)
  }else if(pageName=='wl'){
    // //console.log(pageName)
    nav.push(WelcomeletterPage,this.navParams)
  }else if(pageName=='noc'){
    let loading = this.loadingCtrl.create({
      content:"Please wait..."
    });
    loading.present();
    let request:any={};
    // "ConsumerSysemName":"PORTAL",
    // "transactionId": "0302202336255544",
    // "loanAgreementNo": "HHLBAT00478497",
    // "reqType": "N"
    request.ConsumerSysemName = "PORTAL"
    request.transactionId = (Math.floor((Math.random() * 10000000) + 1)).toString();
    request.loanAgreementNo = localStorage.getItem("cc");
    request.reqType='N'
    let data = this.cp.generatenoc(loading,request) ;
    data.then((res:any)=>{
      loading.dismiss();
       var res=JSON.parse(res)
        
       console.log(res);
       const blob = this.dataURItoBlob(res.Payload.fileData);
       const link = document.createElement('a');
       const url = URL.createObjectURL(blob);
       link.download = "FileName" + new Date() + ".pdf";
       link.click();
      // to open the PDF in a new window
      window.open(url, '_blank');
      // window.open("data:application/pdf;base64," + Base64.encode(res.Payload.fileData));
       
    })
  }
  else{
    //console.log(pageName)
    //this.navCtrl.push(pageName)
  }
  
}

dataURItoBlob(dataURI) {
      const byteString = window.atob(dataURI);
      const arrayBuffer = new ArrayBuffer(byteString.length);
      const int8Array = new Uint8Array(arrayBuffer);
      for (let i = 0; i < byteString.length; i++) {
        int8Array[i] = byteString.charCodeAt(i);
      }
      const blob = new Blob([int8Array], { type: 'application/pdf'});
      return blob;
    }

// data should be your response data in base64 format



}



// WEBPACK FOOTER //
// ./src/pages/documentstatement/documentstatement.ts